
import { Tab, Tabs } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { isUndefined } from 'util';
import { TabsLocalState } from '../../../Interfaces/Interfaces';

const PilotNavTabs = (props:any) => {
	const location = useLocation()
	const locationPathname = location.pathname.split('/');
	const locationState = location.state as TabsLocalState;
	const missionId = locationPathname[2].toLowerCase();
	const currentTab = locationPathname[5].toLowerCase(); 
	const history = useHistory();

	const [state, setState] = useState<string>("Air")

	useEffect(() => {
		switch (currentTab) {
			case 'air':
				setState("Air");
				break;
			case 'ground&naval':
				setState("Ground&Naval");
				break;
			case 'takeoffs&landings':
				setState("Takeoffs&Landings");
				break;
			case 'misc':
				setState("Misc");
				break;
		}
	}, [currentTab])

	const goBackHandler = (evt: object, value: number|string) => {
		if (typeof value === "number") {
			if (!isUndefined(locationState) && locationState[0] === 'campaign') {
				return history.push(`/Mission/${locationState[1]}/Pilots`, locationState);
			}
			history.push(`/Mission/${missionId}/Pilots`);
		}
		else {
			history.push(value, locationState);
		}
	}

	return (
			<Tabs
			onChange={goBackHandler}
				aria-label="pilots tabs"
				variant="scrollable"
				scrollButtons="on"
				value={state}
				style={{ marginTop: 30, marginBottom: 30 }}
			>
				<Tab label="Go Back" value={0}/>
				<Tab label="Air" value="Air"/>
				<Tab label="Ground & Naval" value="Ground&Naval"/>
				<Tab label="Takeoffs & Landings" value="Takeoffs&Landings"/>
				<Tab label="Misc" value="Misc"/>
			</Tabs>
	)
}
export default PilotNavTabs ;
